<template>
  <BasePanelWithHeader headerText="Agency Divisions">
    <v-row v-if="userAdminAgencies.length > 1">
      <v-col>
        <LuAgency
          v-model="selectedAgencyID"
          :items="userAdminAgencies"
        ></LuAgency>
      </v-col>
    </v-row>
    <BaseSimpleDataTable
      v-show="selectedAgencyID > 0"
      :headers="filteredHeaders"
      :items="filteredLuAgencyDivisions"
      :loading="loading"
      search
    >
      <template v-slot:prependParams>
        <v-col cols="12" sm="auto">
          <v-switch v-model="showInactive" label="Show Inactive"></v-switch>
        </v-col>
      </template>
      <template v-slot:appendParams>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.luAgencyDivisionForm.addLuAgencyDivision()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Agency Division
          </BaseTooltipButton>
        </v-col>
      </template>
      <template v-slot:item.edit="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luAgencyDivisionForm.editLuAgencyDivision(item)"
          iconColor="primary"
          icon="mdi-pencil"
          >Edit Agency Division
        </BaseTooltipButton>
      </template>
      <template v-slot:item.delete="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luAgencyDivisionDelete.deleteConfirm(item)"
          iconColor="primary"
          icon="mdi-delete"
          >Delete Agency Division
        </BaseTooltipButton>
      </template>
    </BaseSimpleDataTable>
    <BaseDeleteConfirm
      ref="luAgencyDivisionDelete"
      :delete="deleteLuAgencyDivision"
      @refresh="clearCacheAndReload"
    >
      Are you sure you want to delete this agency division?
    </BaseDeleteConfirm>
    <LuAgencyDivisionDialogForm
      ref="luAgencyDivisionForm"
      :agency="selectedAgencyID"
      @refresh="clearCacheAndReload"
    >
    </LuAgencyDivisionDialogForm>
  </BasePanelWithHeader>
</template>
<script>
import { authComputed } from '@state/helpers'
import { get, sync, commit, call } from 'vuex-pathify'
import LuAgencyDivisionDialogForm from '@components/form/add-edit/LuAgencyDivisionDialog'
import LuAgency from '@components/select/single/LuAgency'
export default {
  components: {
    LuAgencyDivisionDialogForm,
    LuAgency,
  },
  data: () => ({
    showInactive: false,
    selectedAgencyID: 0,
  }),
  created() {
    if (this.userAdminAgencies.length == 1) {
      this.searchAgencyId = [this.userAdminAgencies[0].ID]
      this.selectedAgencyID = this.userAdminAgencies[0].ID
      if (this.searchAgencyId.length > 0) {
        this.loadLuAgencyDivisionsForAgency(this.selectedAgencyID)
      }
    }
  },
  computed: {
    ...authComputed,
    ...get('luAgencyDivision', ['luAgencyDivisions', 'loading']),
    filteredLuAgencyDivisions() {
      var list = this.luAgencyDivisions.filter((i) => true)
      if (!this.showInactive) {
        list = list.filter((i) => i.IsActive)
      }
      return list
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'Id',
          visible: false,
        },
        {
          text: 'Agency Id',
          align: 'center',
          sortable: true,
          value: 'AgencyId',
          visible: false,
        },
        {
          text: 'Description',
          align: 'center',
          sortable: true,
          value: 'Description',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.showInactive,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luAgencyDivision', [
      'deleteLuAgencyDivision',
      'loadLuAgencyDivisionsForAgency',
    ]),
    async clearCacheAndReload() {
      await caches.delete('apilookup-cache')
      this.loadLuAgencyDivisionsForAgency(this.selectedAgencyID)
    },
  },
  watch: {
    selectedAgencyID(nval, oval) {
      if (nval && nval > 0) {
        this.loadLuAgencyDivisionsForAgency(nval)
      }
    },
  },
}
</script>
<style></style>
